export interface CreditEntry {
  role: string
  name: string
}

export interface CreditGroup {
  title: string
  entries: CreditEntry[]
}

export const CREATIVE_TEAM: CreditGroup = {
  title: 'Creative Team',
  entries: [
    { role: 'Director', name: 'Maxim Didenko' },
    { role: 'Choreographer', name: 'Béatrice Larrivée' },
    { role: 'Libretto', name: 'Dmitry Repin & Maxim Didenko' },
    { role: 'Set & Costume Designer', name: 'Galya Solodovnikova' },
    { role: 'Composer', name: 'Paul Traeumer' },
    { role: 'Video Artist', name: 'Oleg Mikhailov' },
    { role: 'Light Artist', name: 'Pavel Zmunchila' },
  ],
}

export const PRODUCTION_STATEMENT =
  'The Doors of Perception is produced and created by Improbable Arts'

export const PRODUCTION: CreditGroup = {
  title: 'Production',
  entries: [
    { role: 'Co-Production', name: 'Orsolina28 Art Foundation' },
    { role: 'General Producers', name: 'Dmitry Repin, Varvara Melnikova' },
  ],
}

export const FULL_CREDITS_PDF_URL =
  'https://cdn.magicpatterns.com/uploads/fbqJf5UPNoirD2rz4jDC36/Full_credits-_Monopol_Berlin_August_2026.pdf'
